// Enum for tile types for clarity and preventing string errors
export enum TileType {
  CHART = 'chart',
  CARD = 'card',
  TABLE = 'table',
  NPS_SCORE = 'nps_score',
}

// Interface for the Tile, representing a reusable component on the report
export interface IReportTile {
  id?: string; // Unique identifier for each tile (optional for new tiles)
  subject_type: string; // Type of report (e.g., jobs, hires)
  componentType: TileType; // Type of component to render (chart, card, table)
  apiConfig?: {
    url?: string; // API endpoint to fetch data for this tile
    requestPayload?: Record<string, any>; // Payload for API requests (e.g., filters)
  };
  transformerKey?: string;
  metadata?: Record<string, any>; // Optional metadata for additional information
  query?: Record<string, any>; // Optional query parameters related to the tile
}
